import { apiRequest } from ".";

export const getCommissionsRequest = (filters) => {
  const {
    page='',
    limit=''
  } = filters;

  // Build query string with all parameters
  const queryParams = new URLSearchParams();
  if (page !== '') queryParams.append('page', page);
  if (limit !== '') queryParams.append('limit', limit);

  const queryString = queryParams.toString();
  const endpoint = `/admin/commissions${queryString ? `?${queryString}` : ''}`;

  return apiRequest(
    endpoint,
    {
      method: 'GET'
    },
    true
  )
}

export const getCommissionRequest = (id) => {
  return apiRequest(
    `/admin/commissions/${id}`,
    {
      method: 'GET'
    },
    true
  )
}

export const updateCommissionRequest = (commission) => {
  return apiRequest(
    `/admin/commissions/${commission._id}`,
    {
      method: 'PUT',
      body: JSON.stringify(commission)
    },
    true
  )
}

export const deleteCommissionRequest = (id) => {
  return apiRequest(
    `/admin/commissions/${id}`,
    {
      method: 'DELETE'
    },
    true
  )
} 